export enum ManagedAccountFieldTypeValue {
  Multiple = "Multiple",
  True = "True",
  False = "False",
  NoBreach = "No breach",
  NotDisclosed = "Not disclosed",
  Empty = "-"
}
